class SummerClosurePopupController {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.storageKey = `summer-closure-dismissed-${this.sectionId}`;
    this.modalId = root.dataset.modalId;
    this.hidePatched = false;
  }

  shouldShow() {
    if (window.Shopify?.designMode) return true;

    const autoDisableDate = this.root.dataset.autoDisableDate;
    if (autoDisableDate) {
      const endDate = new Date(`${autoDisableDate}T23:59:59`);
      if (!Number.isNaN(endDate.getTime()) && new Date() > endDate) {
        return false;
      }
    }

    const dismissedAt = localStorage.getItem(this.storageKey);
    if (!dismissedAt) return true;

    const dismissHours = parseInt(this.root.dataset.dismissHours || '24', 10);
    const dismissMs = dismissHours * 60 * 60 * 1000;
    const elapsed = Date.now() - parseInt(dismissedAt, 10);

    return elapsed >= dismissMs;
  }

  getModal() {
    return (
      document.getElementById(this.modalId) ||
      this.root.querySelector('modal-dialog.summer-closure-popup')
    );
  }

  patchHide(modal) {
    if (this.hidePatched || typeof modal.hide !== 'function') return;

    const originalHide = modal.hide.bind(modal);
    modal.hide = () => {
      if (modal.hasAttribute('open')) {
        this.saveDismissal();
      }
      originalHide();
    };
    this.hidePatched = true;
  }

  bindDismiss(modal) {
    const dismissButton = modal.querySelector('[data-summer-closure-dismiss]');
    dismissButton?.addEventListener('click', () => {
      if (typeof modal.hide === 'function') {
        modal.hide();
      }
    });
  }

  open(modal) {
    if (!this.shouldShow() || typeof modal.show !== 'function') return;
    modal.show();
  }

  saveDismissal() {
    localStorage.setItem(this.storageKey, Date.now().toString());
  }

  async init() {
    if (this.root.dataset.initialized === 'true') return;
    this.root.dataset.initialized = 'true';

    await customElements.whenDefined('modal-dialog');
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const modal = this.getModal();
    if (!modal) return;

    this.patchHide(modal);
    this.bindDismiss(modal);

    const delay = parseFloat(this.root.dataset.showDelay || '1.5') * 1000;
    setTimeout(() => this.open(modal), Number.isNaN(delay) ? 1500 : delay);
  }
}

function initSummerClosurePopups(container = document) {
  container.querySelectorAll('summer-closure-popup[data-enabled="true"]').forEach((root) => {
    new SummerClosurePopupController(root).init();
  });
}

if (!customElements.get('summer-closure-popup')) {
  customElements.define(
    'summer-closure-popup',
    class SummerClosurePopup extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;
        new SummerClosurePopupController(this).init();
      }
    }
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initSummerClosurePopups());
} else {
  initSummerClosurePopups();
}

document.addEventListener('shopify:section:load', (event) => {
  initSummerClosurePopups(event.target);
});
